import { render } from "./MovieTermTable.vue?vue&type=template&id=78f31b3c"
import script from "./MovieTermTable.vue?vue&type=script&lang=js"
export * from "./MovieTermTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__